/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * AuthErrorDtoBase
 * auto generated base class for the model AuthErrorDtoModel.
 */
export const AuthErrorDtoModelBase = ModelBase
  .named('AuthErrorDto')
  .props({
    __typename: types.optional(types.literal("AuthErrorDto"), "AuthErrorDto"),
    message: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class AuthErrorDtoModelSelector extends QueryBuilder {
  get message() { return this.__attr(`message`) }
}
export function selectFromAuthErrorDto() {
  return new AuthErrorDtoModelSelector()
}

export const authErrorDtoModelPrimitives = selectFromAuthErrorDto().message
